import React from 'react';

export default function AdminBehaviorEditGeneral() {
  return <div className="">General Behavior Settings</div>;
}
